var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNewQuality(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2H10C10 0.896875 9.10313 0 8 0C6.89687 0 6 0.896875 6 2H3.5C2.67188 2 2 2.67188 2 3.5V14.5C2 15.3281 2.67188 16 3.5 16H12.5C13.3281 16 14 15.3281 14 14.5V3.5C14 2.67188 13.3281 2 12.5 2ZM8 1.25C8.41563 1.25 8.75 1.58438 8.75 2C8.75 2.41563 8.41563 2.75 8 2.75C7.58437 2.75 7.25 2.41563 7.25 2C7.25 1.58438 7.58437 1.25 8 1.25ZM11.7875 8.49375L7.31875 12.925C7.17188 13.0719 6.93437 13.0688 6.7875 12.9219L4.20625 10.3188C4.05938 10.1719 4.0625 9.93438 4.20937 9.7875L5.09687 8.90625C5.24375 8.75937 5.48125 8.7625 5.62812 8.90938L7.06563 10.3594L10.3781 7.07188C10.525 6.925 10.7625 6.92812 10.9094 7.075L11.7906 7.9625C11.9375 8.1125 11.9344 8.34687 11.7875 8.49375Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewQuality);
export default __webpack_public_path__ + "static/media/icon--new-quality.1f912cfdc1fa0d63f2164541ef8ee9d9.svg";
export { ForwardRef as ReactComponent };